import React, { createContext, useContext, useState } from "react";

const CursorContext = createContext();

export const useCursor = () => useContext(CursorContext);

export const MagicCursorProvider = ({ children }) => {
  const [cursorStyle, setCursorStyle] = useState("");
  const [cursorText, setCursorText] = useState(""); // 💬 Add this

  return (
    <CursorContext.Provider
      value={{ cursorStyle, setCursorStyle, cursorText, setCursorText }}
    >
      {children}
    </CursorContext.Provider>
  );
};
